<button type="button" class="c-text-input__show-password" *ngIf="!isShown" (click)="showHide()" tabindex="-1" aria-label="Show password">
    Show
    <svg class="c-ic c-ic--xs c-ic-white c-text-input__show-password__ic"> <use xlink:href="#ic-hide-passs" href="#ic-hide-pass"></use></svg>
</button>
<button type="button" class="c-text-input__show-password" *ngIf="isShown" (click)="showHide()" tabindex="-1"  aria-label="Hide password">
    Hide
    <svg class="c-ic c-ic--xs c-ic-white c-text-input__show-password__ic"> <use xlink:href="#ic-show-pass" href="#ic-show-pass"></use></svg>
</button>
